'use strict';

var enumerate = require('../../enumerate');

module.exports = enumerate([
  'DISPATCH_FRAME_READY',
  'DISPATCH_FRAME_REPORT'
], 'frameService:');



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web/lib/frame-service/shared/events.js
// module id = 539
// module chunks = 1